import http from '../http'
import QS from 'qs'

/**
 * 例子
 * post方法，对应post请求
 * @param data
 * @returns {AxiosPromise}
 */
export function userRejsiter(data) {
  return http({
    url: '/api/device/types',
    method: 'post',
    data: QS.stringify(data)
  })
}

/**
 * 获取设备
 * get方法，对应get请求
 * @returns {AxiosPromise}
 */
export function getDevicesInfo() {
  return http({
    // url: '/api/tenant/dashboards?limit=100',
    url: '/api/tenant/devices?limit=10000',
    method: 'get'
  })
}

/**
 * 获取设备类型
 * get方法，对应get请求
 * @returns {AxiosPromise}
 */
export function getCredentials(entityId) {
  return http({
    url: '/api/device/' + entityId + '/credentials',
    method: 'get'
  })
}

/**
 * 获取遥测数据的key值
 * get方法，对应get请求
 * @returns {AxiosPromise}
 */
export function getDeviceKey(entityType, id) {
  return http({
    url: '/api/plugins/telemetry/' + entityType + '/' + id + '/keys/timeseries',
    method: 'get'
  })
}

/**
 * 获取最新遥测数据
 * get方法，对应get请求
 * @returns {AxiosPromise}
 */
export function getDeviceValue(entityType, id, key) {
  return http({
    url: '/api/plugins/telemetry/' + entityType + '/' + id + '/values/timeseries?keys=' + key,
    method: 'get'
  })
}

/**
 * 获取历史遥测数据
 * get方法，对应get请求
 * '/api/plugins/telemetry/' + entityType + '/' + id + '/values/timeseries?keys=' + key + '&startTs=1609430400000&endTs=1672502400000&interval=6000&limit=1000&agg=NONE',
 * @returns {AxiosPromise}
 */
export function getDeviceHistory(entityType, id, key) {
  return http({
    url: '/api/plugins/telemetry/' + entityType + '/' + id + '/values/timeseries?keys=' + key + '&startTs=1577808000000&endTs=1672502400000&interval=6000&limit=1000&agg=NONE',
    method: 'get'
  })
}

/**
 * 根据时间获取历史遥测数据
 * get方法，对应get请求
 * '/api/plugins/telemetry/' + entityType + '/' + id + '/values/timeseries?keys=' + key + '&startTs=1609430400000&endTs=1672502400000&interval=6000&limit=1000&agg=NONE',
 * @returns {AxiosPromise}
 */
export function getTimeDeviceHistory(entityType, id, key, start, end, interval, agg) {
  return http({
    url: '/api/plugins/telemetry/' + entityType + '/' + id + '/values/timeseries?keys=' + key + '&startTs=' + start + '&endTs=' + end + '&interval=' + interval + '&limit=1440&agg=' + agg,
    method: 'get'
  })
}

/**
 *获取普通用户的设备
 * get方法，对应get请求/api/plugins/telemetry/DEVICE/8c603320-8b88-11eb-9551-09f66552be9a/values/attributes/SERVER_SCOPE
 * @returns {AxiosPromise}
 */
export function getCustomerDevice(customerId) {
  return http({
    url: '/api/customer/' + customerId + '/' + 'devices?limit=1000',
    method: 'get'
  })
}

/**
 * 获取服务端数据
 * @param entityType
 * @param deviceId
 * @returns {AxiosPromise}
 */
export function getAttributesServer(entityType, deviceId) {
  return http({
    url: '/api/plugins/telemetry/' + entityType + '/' + deviceId + '/values/attributes/SERVER_SCOPE',
    method: 'get'
  })
}

/**
 * 获取共享端数据
 * @param entityType
 * @param deviceId
 * @returns {AxiosPromise}
 */
export function getAttributesShared(entityType, deviceId) {
  return http({
    url: '/api/plugins/telemetry/' + entityType + '/' + deviceId + '/values/attributes/SHARED_SCOPE',
    method: 'get'
  })
}

/**
 * 获取指定设备信息
 * @param deviceId
 * @returns {AxiosPromise}
 */

export function getDeviceName(deviceId) {
  return http({
    url: '/api/device/' + deviceId,
    method: 'get'
  })
}

/**
 * 往客户端传递值的上下限值
 * @param access
 * @param param
 * @returns {AxiosPromise}
 */
export function clientInfo(access, param) {
  return http({
    url: '/api/v1/' + access + '/attributes',
    method: 'post',
    data: param
  })
}

/**
 * 获取客户端值
 * @param access
 * @returns {AxiosPromise}
 */
export function getAttributesClient(access) {
  return http({
    url: '/api/v1/' + access + '/attributes',
    method: 'get'
  })
}

/**
 * 获取最后一次连接数据
 * @param entityType
 * @param deviceId
 * @returns {AxiosPromise}
 */
export function getConnectTime(entityType, deviceId) {
  return http({
    url: '/api/plugins/telemetry/'+ entityType + '/' + deviceId + '/values/attributes/SERVER_SCOPE?keys=lastActivityTime',
    method: 'get'
  })
}




// WEBPACK FOOTER //
// ./src/untils/api/home.js